// Shared route/page groups used by the startup redirect logic
// (src/hooks/useStartupRedirect.js) and by containers that need to know where a
// signed-in user belongs (`defaultInnerPage`).
export const registrationPages = [
  "sign-up",
  "add-email",
  "restore-password",
  "getting_started",
  "verify-code",
  "success",
  "auth",
  "mcp"
]

export const innerPagesMainApp = [
  "onboarding",
  "home",
  "prevent",
  "deflect",
  "alerts",
  // Recover pages must survive a reload the same way Alerts does — without this a
  // merchant on any /recover/* address is redirected to their default page.
  "recover",
  "integrations",
  "developers",
  "dashboard",
  "settings",
  "business_settings",
  "connect-shopify",
  "create-account",
  "business_accounts",
  "requests",
  "invoices",
  "referral",
  "pricing",
  "users",
  "credits",
  "configure",
  "marketing",
  "team",
  "digital-receipt",
  "health",
  "admin/2fa-verification",
  "admin/2fa-setup",
  "manual-top-up",
  "add-card",
  "getting_started",
  "mcp",
  "security",
  "admin_users",
  "perks",
  "payment_matching",
  "receipts",
  // Not a screen — the route at /help leaves for the help site. It has to be
  // listed here anyway, or startup redirects the address away before the route
  // gets to run (CHA1-3116).
  "help"
]

export const innerPagesPartner = ["referral"]

export const authPaths = ["/auth/shopify", "/auth/stripe", "/auth/nextcommerce"]

const appType = process.env.REACT_APP_TYPE

export const defaultInnerPage = appType === "partner" ? "/referrals" : "/getting_started"
export const innerPages = appType === "partner" ? innerPagesPartner : innerPagesMainApp
export const signUpPage = appType === "partner" ? "/" : "/sign-up"
